import { memo, useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";
import { StockTable } from "@/components/features/items/stock/_shared/components/table";
import { StockTableHeader } from "@/components/features/items/stock/_shared/components/table/header";

import { OptionStockTableRows } from "./components/rows";
import { useOptionStockTablePresenter } from "./hooks/use-option-table-presenter";

import type { OptionStockDiffStore } from "../../../../../model/usecase/use-create-form-model/option-stock-diff-store";
import type { ServerModel } from "../../../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	optionStockDiffStore: OptionStockDiffStore;
	selectedItemIDs: string[];
};

export const OptionStockTableForLaptop = memo(({ serverModel, optionStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredOptionStock, currentMonth, currentYear } = useOptionStockTablePresenter({
		serverModel,
		selectedItemIDs,
	});

	const { headers, items, hotelID } = filteredOptionStock;

	/**
	 * 在庫一覧を表示するか
	 */
	const canShowStockList = useMemo(() => items.length > 0, [items.length]);

	return (
		<StockTable currentYearAndMonth={{ year: currentYear, month: currentMonth }}>
			{canShowStockList ? (
				<>
					<StockTableHeader headers={headers} />
					<OptionStockTableRows items={items} hotelID={hotelID} optionStockDiffStore={optionStockDiffStore} />
				</>
			) : (
				<BlankContentForList content="表示するオプションがありません。" />
			)}
		</StockTable>
	);
});

OptionStockTableForLaptop.displayName = "OptionStockTableForLaptop";
